import { createReducer, on } from '@ngrx/store';
import { ScheduleInterface } from 'src/app/core/models/operator-schedule.model';
import * as OperatorSchedulesActions from '../actions/operator-schedules.actions';

export const operatorSchedulesFeatureKey = 'operatorSchedules';

export interface State {
  schedules: ScheduleInterface[];
  availableVehicleIdList: number[];
  assignedVehicleIdList: number[];
  loading: boolean;
}

export const initialState: State = {
  schedules: [],
  availableVehicleIdList: [],
  assignedVehicleIdList: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,

  on(
    OperatorSchedulesActions.loadOperatorSchedules,
    OperatorSchedulesActions.loadAllAvailableVehicles,
    OperatorSchedulesActions.loadAllAssignedVehicles,
    OperatorSchedulesActions.addOperatorSchedules,
    OperatorSchedulesActions.updateOperatorSchedules,
    OperatorSchedulesActions.deleteOperatorSchedules,
    (state) => ({
      ...state,
      loading: true,
    }),
  ),
  on(
    OperatorSchedulesActions.loadOperatorSchedulesSuccess,
    (state, action) => ({
      ...state,
      schedules: action.events,
      loading: false,
    }),
  ),

  on(
    OperatorSchedulesActions.loadAllAvailableVehiclesSuccess,
    (state, action) => ({
      ...state,
      availableVehicleIdList: action.vehicleIdList,
      loading: false,
    }),
  ),
  on(
    OperatorSchedulesActions.loadAllAssignedVehiclesSuccess,
    (state, action) => ({
      ...state,
      assignedVehicleIdList: action.vehicleIdList,
      loading: false,
    }),
  ),
  on(OperatorSchedulesActions.addAssignedVehicle, (state, action) => ({
    ...state,
    assignedVehicleIdList: [...state.assignedVehicleIdList, action.vehicleId],
  })),

  on(OperatorSchedulesActions.removeAssignedVehicle, (state, action) => ({
    ...state,
    assignedVehicleIdList: state.assignedVehicleIdList.filter(
      (id) => id !== action.vehicleId,
    ),
  })),

  on(OperatorSchedulesActions.removeAvailableVehicle, (state, action) => ({
    ...state,
    availableVehicleIdList: state.availableVehicleIdList.filter(
      (id) => id !== action.vehicleId,
    ),
  })),

  on(OperatorSchedulesActions.addOperatorSchedulesSuccess, (state, action) => ({
    ...state,
    schedules: [action.event, ...state.schedules],
    loading: false,
  })),
  on(
    OperatorSchedulesActions.updateOperatorSchedulesSuccess,
    (state, action) => ({
      ...state,
      schedules: state.schedules.map((event) =>
        event.id === action.event.id ? action.event : event,
      ),

      loading: false,
    }),
  ),
  on(
    OperatorSchedulesActions.deleteOperatorSchedulesSuccess,
    (state, action) => ({
      ...state,
      schedules: state.schedules.filter((event) => event.id !== action.id),
      loading: false,
    }),
  ),

  on(OperatorSchedulesActions.operatorSchedulesError, (state) => ({
    ...state,
    loading: false,
  })),
  on(OperatorSchedulesActions.operatorSchedulesClear, (state) => ({
    ...state,
    schedules: [] as ScheduleInterface[],
  })),
);

export const getOperatorSchedules = (state: State) => state.schedules;
export const getOperatorSchedulesLoading = (state: State) => state.loading;
export const getAvailableVehicles = (state: State) =>
  state.availableVehicleIdList;
export const getAssignedVehicles = (state: State) =>
  state.assignedVehicleIdList;
